import { createSlice } from "@reduxjs/toolkit";

const initialState = { 
    ordersCount: 0,
    cancelledOrdersCount: 0,
    outOfDeliveryOrdersCount: 0,
    awaitCourrierOrdersCount: 0,
    todoOrdersCount: 0,
    dropOffOrdersCount: 0
}

const DeliveryOrdersCountSlice = createSlice({
    name: "deliveryOrdersCount",
    initialState,
    reducers: {
        setOrdersCount: (state, action) => {
            state.ordersCount = action.payload
        },
        setCancelledOrdersCount: (state, action) => {
            state.cancelledOrdersCount = action.payload
        },
        setOutOfDeliveryOrdersCount: (state, action) => {
            state.outOfDeliveryOrdersCount = action.payload
        },
        setAwaitCourrierOrdersCount: (state, action) => {
            state.awaitCourrierOrdersCount = action.payload
        },
        setTodoOrdersCount: (state, action) => {
            state.todoOrdersCount = action.payload
        },
        setDropOffOrdersCount: (state, action) => {
            state.dropOffOrdersCount = action.payload
        },
    }
})

export const { setOrdersCount, setCancelledOrdersCount, setOutOfDeliveryOrdersCount, setAwaitCourrierOrdersCount, setTodoOrdersCount, setDropOffOrdersCount} = DeliveryOrdersCountSlice.actions;
export default DeliveryOrdersCountSlice.reducer; 